export function checkObjectParameterDiffToValue(object, obj1, obj2) {
  let diffArrayKey = []
  let array = []
  if (object instanceof Object) {
    array = Object.keys(object)
  }
  array.forEach((key) => {
    if (obj1.hasOwnProperty(key) === obj2.hasOwnProperty(key)) {
      if (obj1[key] !== obj2[key]) {
        diffArrayKey.push(key)
      }
    }
  })
  let diffArrayValue = []
  for (let i = 0; i < diffArrayKey.length; i++) {
    diffArrayValue.push(object[diffArrayKey[i]])
  }
  return { diffArrayKey, diffArrayValue }
}



// WEBPACK FOOTER //
// ./src/assets/js/tool/checkObjectUtils.js